<template>
    <div class="tyn-root">
        <div class="tyn-content tyn-auth tyn-auth-centered">
            <div class="auth-bg">
                <span class="drop" v-for="n in 12" :key="n"></span>
            </div>

            <div class="container auth-container">
                <div class="row justify-content-center">
                    <div class="col-xl-4 col-lg-5 col-md-7 col-sm-9 auth-col">
                        <div class="my-3 text-center">
                            <a class="tyn-logo tyn-logo-sm auth-logo" href="index.html">
                                <img src="assets/images/sollai/logo.png" alt="SollAi">
                            </a>
                        </div>

                        <div class="card border-0 auth-card">
                            <div class="p-4 p-md-5">
                                <h3 class="auth-title mb-1">Bem vindo!</h3>
                                <p class="auth-subtitle mb-4">Acesse sua conta para continuar.</p>

                                <div class="row g-3">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label class="form-label" for="userName">Email</label>
                                            <div class="form-control-wrap">
                                                <input type="text"
                                                       class="form-control"
                                                       name="user-name"
                                                       id="userName"
                                                       placeholder="Digite seu Email"
                                                       v-model="user.login"
                                                       required>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <div class="form-group">
                                            <label class="form-label d-flex" for="userPassword">
                                                Senha
                                                <a href="javascript:void(0)"
                                                   @click="showModal = !showModal"
                                                   class="link link-primary ms-auto auth-link">
                                                    esqueceu sua senha ?
                                                </a>
                                            </label>

                                            <div class="form-control-wrap position-relative mb-2">
                                                <input :type="showPassword ? 'text' : 'password'"
                                                       class="form-control pe-5"
                                                       name="user-Password"
                                                       id="userPassword"
                                                       placeholder="Digite sua Senha"
                                                       v-model="user.password"
                                                       @keyup.enter="entrar"
                                                       required />

                                                <span v-if="capsLockOn" class="caps-lock-alert">
                                                    ⚠ Caps Lock está ativado!
                                                </span>

                                                <button type="button"
                                                        class="btn toggle-password-btn position-absolute top-50 end-0 translate-middle-y me-2 p-0"
                                                        @click="showPassword = !showPassword">
                                                    <svg v-if="showPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                                         class="bi bi-eye-slash" viewBox="0 0 16 16">
                                                        <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z" />
                                                        <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829" />
                                                        <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z" />
                                                    </svg>
                                                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                                         class="bi bi-eye" viewBox="0 0 16 16">
                                                        <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                                        <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <button class="btn btn-primary w-100 auth-btn"
                                                type="button"
                                                @click="entrar"
                                                :disabled="loading">
                                            <span v-if="!loading">Entrar</span>
                                            <span v-else class="d-inline-flex align-items-center justify-content-center">
                                                <span class="spinner me-2"></span>
                                                Entrando...
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="text-center mt-4">
                            <p class="small auth-footer">
                                Se você ainda não possui uma conta, por favor, solicite uma agora.
                                <a href="javascript:void(0)"
                                   @click="showExperimenteGratis = !showExperimenteGratis"
                                   class="auth-link-strong">
                                    Solicite!
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <EsqueciMinhaSenha :showModal="showModal"></EsqueciMinhaSenha>
        <ExperimenteGratis :showModal="showExperimenteGratis"></ExperimenteGratis>
    </div>
</template>


<script>
    import EsqueciMinhaSenha from '@/components/EsqueciMinhaSenha'
    import ExperimenteGratis from '@/components/ExperimenteGratis'

    import { urlApi, avisoErro, applyAuthToStore } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'Login',
        components: { EsqueciMinhaSenha, ExperimenteGratis },
        data() {
            return {
                user: {
                    login: "",
                    password: "",
                },
                showModal: false,
                showExperimenteGratis: false,
                passwordField: true,
                capsLockOn: false,
                showPassword: false,
                loading: false,
            }
        },
        methods: {
            async entrar() {
                if (this.loading) return
                this.loading = true

                try {
                    const res = await axios.post(`${urlApi}/Auth/signin`, this.user)

                    if (res.data.token.authenticated) {
                        applyAuthToStore(this.$store, res.data)
                        this.$router.push({ name: 'Home' })
                    } else {
                        avisoErro("Erro ao realizar login.")
                    }
                } catch (e) {
                    avisoErro("Login e/ou senha inválidos.")
                } finally {
                    this.loading = false
                }
            },
            checkCapsLockGlobal(e) {
                if (typeof e.getModifierState === 'function') {
                    this.capsLockOn = e.getModifierState('CapsLock');
                }
            }
        },
        mounted() {
            window.addEventListener('keydown', this.checkCapsLockGlobal);
            window.addEventListener('keyup', this.checkCapsLockGlobal);
        },
        destroyed() {
            window.removeEventListener('keydown', this.checkCapsLockGlobal);
            window.removeEventListener('keyup', this.checkCapsLockGlobal);
        },
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .tny-auth,
    .tyn-auth {
        position: relative;
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        background: linear-gradient(135deg, #e0f2ff 0%, #f5f7ff 50%, #e0f7f4 100%);
    }

    .auth-bg {
        position: absolute;
        inset: 0;
        pointer-events: none;
        overflow: hidden;
    }

    .auth-bg .drop {
        position: absolute;
        width: 140px;
        height: 140px;
        border-radius: 999px;
        opacity: 0;
        filter: blur(18px);
        background: radial-gradient(circle at 30% 20%, rgba(255, 255, 255, 0.9) 0, rgba(255, 255, 255, 0) 55%), radial-gradient(circle at center, var(--drop-color) 0, rgba(0, 0, 0, 0) 70%);
        animation: dropCycle 26s ease-in-out infinite;
    }

    .auth-bg .drop:nth-child(1) {
        left: 6%;
        top: 68%;
        width: 290px;
        height: 290px;
        --drop-color: rgba(191, 80, 226, 0.6);
        animation-duration: 24s;
        animation-delay: 0s;
    }

    .auth-bg .drop:nth-child(2) {
        left: 10%;
        top: 22%;
        width: 150px;
        height: 150px;
        --drop-color: rgba(0, 73, 178, 0.5);
        animation-duration: 30s;
        animation-delay: -6s;
    }

    .auth-bg .drop:nth-child(3) {
        left: 35%;
        top: 65%;
        width: 320px;
        height: 320px;
        --drop-color: rgba(0, 198, 191, 0.55);
        animation-duration: 28s;
        animation-delay: -12s;
    }

    .auth-bg .drop:nth-child(4) {
        left: 9%;
        top: 22%;
        width: 670px;
        height: 670px;
        --drop-color: rgba(0, 220, 95, 0.55);
        animation-duration: 32s;
        animation-delay: -18s;
    }

    .auth-bg .drop:nth-child(5) {
        left: 64%;
        top: 50%;
        width: 310px;
        height: 310px;
        --drop-color: rgba(0, 162, 167, 0.55);
        animation-duration: 23s;
        animation-delay: -9s;
    }

    .auth-bg .drop:nth-child(6) {
        left: 78%;
        top: 30%;
        width: 160px;
        height: 160px;
        --drop-color: rgba(108, 74, 214, 0.55);
        animation-duration: 29s;
        animation-delay: -3s;
    }

    .auth-bg .drop:nth-child(7) {
        left: 88%;
        top: 10%;
        width: 295px;
        height: 295px;
        --drop-color: rgba(0, 220, 95, 0.5);
        animation-duration: 26s;
        animation-delay: -15s;
    }

    .auth-bg .drop:nth-child(8) {
        left: 12%;
        top: 12%;
        width: 180px;
        height: 180px;
        --drop-color: rgba(0, 198, 191, 0.5);
        animation-duration: 34s;
        animation-delay: -20s;
    }

    .auth-bg .drop:nth-child(9) {
        left: 40%;
        top: 10%;
        width: 120px;
        height: 120px;
        --drop-color: rgba(191, 80, 226, 0.55);
        animation-duration: 22s;
        animation-delay: -10s;
    }

    .auth-bg .drop:nth-child(10) {
        left: 56%;
        top: 75%;
        width: 530px;
        height: 530px;
        --drop-color: rgba(0, 73, 178, 0.55);
        animation-duration: 27s;
        animation-delay: -4s;
    }

    .auth-bg .drop:nth-child(11) {
        left: 70%;
        top: 14%;
        width: 100px;
        height: 100px;
        --drop-color: rgba(0, 220, 95, 0.55);
        animation-duration: 21s;
        animation-delay: -14s;
    }

    .auth-bg .drop:nth-child(12) {
        left: 90%;
        top: 44%;
        width: 350px;
        height: 350px;
        --drop-color: rgba(0, 198, 191, 0.6);
        animation-duration: 31s;
        animation-delay: -7s;
    }

    @keyframes dropCycle {
        0% {
            transform: translate3d(0, -30px, 0) scale(0);
            opacity: 0;
        }

        18% {
            transform: translate3d(0, 0, 0) scale(1);
            opacity: 0.65;
        }

        32% {
            transform: translate3d(0, 6px, 0) scale(1.15);
            opacity: 0.8;
        }

        70% {
            transform: translate3d(0, 10px, 0) scale(0.7);
            opacity: 0.35;
        }

        100% {
            transform: translate3d(0, 14px, 0) scale(0);
            opacity: 0;
        }
    }

    .auth-container {
        position: relative;
        z-index: 1;
    }

    .auth-logo img {
        height: 60px;
        animation: floatLogo 10s ease-in-out infinite alternate;
    }

    .auth-card {
        border-radius: 24px;
        background: rgba(255, 255, 255, 0.92);
        backdrop-filter: blur(20px);
        box-shadow: 0 24px 60px rgba(15, 23, 42, 0.18);
        animation: cardIn 0.6s ease-out;
    }

    .auth-title {
        font-weight: 700;
        color: #0f172a;
    }

    .auth-subtitle {
        font-size: 0.95rem;
        color: #6b7280;
    }

    .form-group {
        margin-bottom: 1.25rem;
        transition: transform 0.18s ease, box-shadow 0.18s ease;

        &:focus-within {
            transform: translateY(-1px);
        }

        &:focus-within .form-label {
            color: #2563eb;
        }
    }

    .form-label {
        font-weight: 500;
        color: #4b5563;
        margin-bottom: 0.35rem;
    }

    .form-control-wrap {
        position: relative;
    }

    @media (max-width: 576px) {
        .form-control-wrap {
            position: relative !important;
        }
    }

    input.form-control {
        border-radius: 12px;
        border: 1px solid #e5e7eb;
        background-color: #f3f6ff;
        padding: 0.7rem 0.95rem;
        padding-right: 2.5rem;
        font-size: 0.95rem;
        transition: border-color 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease;

        &:focus {
            border-color: #2563eb;
            background-color: #ffffff;
            box-shadow: 0 0 0 1px #2563eb33;
            outline: none;
        }
    }

    @media (max-width: 576px) {
        input.form-control {
            padding-right: 2.75rem;
        }

        #userPassword {
            padding-right: 2.75rem !important;
        }
    }

    .toggle-password-btn {
        background: transparent;
        border: 0;
        border-radius: 999px;
        line-height: 0;
        cursor: pointer;
        transition: background-color 0.15s ease, transform 0.15s ease;
        width: auto;
        height: auto;
        min-width: 32px;
        min-height: 32px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        z-index: 10;

        &:hover {
            background-color: rgba(148, 163, 184, 0.15);
            transform: scale(1.03);
        }
    }

    @media (max-width: 576px) {
        .toggle-password-btn {
            position: absolute !important;
            top: 50% !important;
            right: 0.5rem !important;
            transform: translateY(-50%) !important;
            left: auto !important;
            width: 32px !important;
            height: 32px !important;
            margin: 0 !important;
        }
    }

    .caps-lock-alert {
        font-size: 0.75rem;
        color: #dc3545;
        position: absolute;
        top: 100%;
        left: 0;
        margin-top: 0.25rem;
        white-space: nowrap;
        z-index: 5;
    }

    .auth-btn {
        border-radius: 999px;
        font-weight: 600;
        padding: 0.75rem 1rem;
        border: none;
        background-image: linear-gradient(90deg, #2563eb, #06b6d4);
        box-shadow: 0 12px 30px rgba(37, 99, 235, 0.45);
        transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;

        &:hover:not(:disabled) {
            transform: translateY(-1px);
            box-shadow: 0 16px 36px rgba(37, 99, 235, 0.55);
            filter: brightness(1.02);
        }

        &:active:not(:disabled) {
            transform: translateY(0);
            box-shadow: 0 10px 24px rgba(37, 99, 235, 0.45);
        }

        &:disabled {
            opacity: 0.8;
            cursor: default;
            box-shadow: 0 8px 20px rgba(148, 163, 184, 0.5);
        }
    }

    .spinner {
        width: 16px;
        height: 16px;
        border-radius: 999px;
        border: 2px solid rgba(255, 255, 255, 0.5);
        border-top-color: #fff;
        animation: spin 0.8s linear infinite;
    }

    .auth-footer {
        color: #6b7280;
    }

    .auth-link {
        font-size: 0.85rem;
    }

    .auth-link-strong {
        color: #2563eb;
        font-weight: 600;
        text-decoration: none;
        margin-left: 0.25rem;
        position: relative;

        &:hover {
            text-decoration: underline;
        }
    }
    .auth-col {
        width: 100%;
        max-width: 420px;
    }

    @media (min-width: 1200px) {
        .auth-col {
            max-width: 460px;
        }
    }

    @keyframes cardIn {
        from {
            opacity: 0;
            transform: translateY(16px) scale(0.98);
        }

        to {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
    }

    @keyframes floatLogo {
        from {
            transform: translateY(0px);
        }

        to {
            transform: translateY(-6px);
        }
    }

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }

    @media (max-width: 576px) {
        .auth-card {
            border-radius: 18px;
        }

        .auth-title {
            font-size: 1.3rem;
        }

        .auth-subtitle {
            font-size: 0.9rem;
        }
    }
</style>



